var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68130_232854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.29365V29.7064C8 31.2492 9.23122 32.5 10.75 32.5H29.25C30.7688 32.5 32 31.2492 32 29.7064V7.85127C32 7.10502 31.7061 6.38979 31.1838 5.86503L26.6478 1.30741C26.133 0.79013 25.4381 0.5 24.714 0.5H10.75C9.23122 0.5 8 1.75076 8 3.29365ZM9.75 29.7064V3.29365C9.75 2.7326 10.1977 2.27778 10.75 2.27778H24.375V8.37302C24.375 9.42499 25.2145 10.2778 26.25 10.2778H30.25V29.7064C30.25 30.2674 29.8023 30.7222 29.25 30.7222H10.75C10.1977 30.7222 9.75 30.2674 9.75 29.7064ZM30.25 8.5V7.85127C30.25 7.57991 30.1431 7.31982 29.9532 7.129L26.125 3.28254V8.37302C26.125 8.44315 26.181 8.5 26.25 8.5H30.25Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 13.625C20.5 13.1418 20.8918 12.75 21.375 12.75H27.125C27.6082 12.75 28 13.1418 28 13.625C28 14.1082 27.6082 14.5 27.125 14.5H21.375C20.8918 14.5 20.5 14.1082 20.5 13.625Z",
    fill: "#69C997"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 17.625C20.5 17.1418 20.8918 16.75 21.375 16.75H27.125C27.6082 16.75 28 17.1418 28 17.625C28 18.1082 27.6082 18.5 27.125 18.5H21.375C20.8918 18.5 20.5 18.1082 20.5 17.625Z",
    fill: "#54AD7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 21.625C20.5 21.1418 20.8918 20.75 21.375 20.75H27.125C27.6082 20.75 28 21.1418 28 21.625C28 22.1082 27.6082 22.5 27.125 22.5H21.375C20.8918 22.5 20.5 22.1082 20.5 21.625Z",
    fill: "#2B593D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.75C0 8.92157 0.671573 8.25 1.5 8.25H16.5C17.3284 8.25 18 8.92157 18 9.75V24.75C18 25.5784 17.3284 26.25 16.5 26.25H1.5C0.671573 26.25 0 25.5784 0 24.75V9.75Z",
    fill: "#3D8A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 22.2715L7.80957 17.042L5.25977 12.25H7.20117L8.84863 15.4697L10.4619 12.25H12.3828L9.83301 17.1172L12.6426 22.2715H10.6396L8.81445 18.8057L6.98926 22.2715H5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68130_232854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.7cff232b4108372a2b774d54262317cf.svg";
export { ForwardRef as ReactComponent };